import { Popover as PopoverPrimitive } from "@base-ui/react/popover"

import { cn } from "#Utils/cn"

function PopOver(props) {
  return <PopoverPrimitive.Root data-slot="popover" {...props} />
}

function PopOverTrigger(props) {
  return <PopoverPrimitive.Trigger data-slot="popover-trigger" {...props} />
}

function PopOverContent(props) {
  const {
    className,
    align = "center",
    side,
    sideOffset = 4,
    anchor,
    collisionAvoidance,
    ...contentProps
  } = props

  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Positioner
        anchor={anchor}
        className="z-1000"
        align={align}
        side={side}
        sideOffset={sideOffset}
        collisionAvoidance={collisionAvoidance}
      >
        <PopoverPrimitive.Popup
          data-slot="popover-content"
          className={cn("c-popover relative outline-hidden", className)}
          {...contentProps}
        />
      </PopoverPrimitive.Positioner>
    </PopoverPrimitive.Portal>
  )
}

PopOverContent.propTypes = {
  className: PropTypes.string,
  align: PropTypes.oneOf(["start", "center", "end"]),
  side: PropTypes.oneOf(["left", "right", "bottom", "top"]),
  sideOffset: PropTypes.number,
  anchor: PropTypes.node,
  collisionAvoidance: PropTypes.object,
}

export { PopOver, PopOverContent, PopOverTrigger }
